import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import React from "react";

const CompanyBasicInfoSkeleton = () => {
	return (
        <Box sx={{ maxWidth: "1300px", mt: "16px", pb: "8px" }}>
            <Grid container rowSpacing={3}>
				<Grid container columnSpacing={5} rowSpacing={0} size={12}>
					<Grid
                        size={{
                            xs: 12,
                            sm: 8,
                            md: 3
                        }}>
						<Skeleton variant="rectangular" height={36.56} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 8,
                            md: 6
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 4,
                            md: 3
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
				</Grid>
				<Grid container columnSpacing={5} rowSpacing={0} size={12}>
					<Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 1.5
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 2.5
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 3
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 4
                        }}>
						<Skeleton variant="rectangular" height={36.71} />
					</Grid>
					<Grid
                        size={{
                            xs: 12,
                            sm: 6,
                            md: 1
                        }}>
						<Skeleton variant="rectangular" width={71.65} height={35.8} />
					</Grid>
				</Grid>
			</Grid>
        </Box>
    );
};

export default CompanyBasicInfoSkeleton;
